import { DatasetSyncConfig } from "@dashboard-v3/api";
import { CreateForm, EditForm } from "../Sync/SyncConfigForm";

type Params = {
  datasetName: string;
  /** Only when editing: the dataset the sync belongs to. */
  datasetId?: string;
  /** Only when creating: items loaded by hand in the "Items" tab. */
  rows?: Record<string, string[]>;
  sync?: DatasetSyncConfig;
};

/**
 * Builds the state for the sync config form.
 *
 * The `datasetId` is what tells the form to update the dataset being edited
 * instead of creating a new one, so it must be kept even when the dataset has
 * no sync config yet (MXH-5795).
 */
export default function buildSyncForm({
  datasetName,
  datasetId,
  rows,
  sync,
}: Params): CreateForm | EditForm {
  const id = datasetId || sync?.datasetId;

  if (sync) {
    return {
      datasetName,
      datasetId: id,
      action: sync.action,
      repeatEvery: ((sync.schedule?.everyMins || 0) / 60) as 0 | 6 | 12 | 24,
      params: sync.params,
    } as EditForm;
  }

  const form = {
    action: "REPLACE",
    repeatEvery: 0,
    datasetName: datasetName,
    params: {
      type: "FILE",
      parentId: "",
      useAsKey: "id",
      useAsValue: "name",
      storageUser: "",
      storageAccountId: "",
    },
  };

  if (id) return { ...form, datasetId: id } as EditForm;

  // The dataset does not exist yet: the API creates it with these items and
  // then runs the sync over them.
  return { ...form, rows: rows || {} } as CreateForm;
}
